import React from 'react';
import { Box, Alert, AlertTitle, Typography } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { useTranslation } from 'react-i18next';
import SatelliteDataReportSubHeader from '../../../../components/SatelliteDataReport/SatelliteDataReportSubHeader';
import AmSatelliteReportMapSection from './AmSatelliteReportMapSection';

const AmReportSatelliteIndexSection = ({
  farmSatelliteData,
  title,
  activeTile,
  id,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        '@media print': {
          pageBreakInside: 'avoid',
          marginBottom: '3mm',
        },
      }}
      id={id}
    >
      <SatelliteDataReportSubHeader text={title} />
      <Box
        sx={{
          p: 2,
          borderRadius: 0,
          '@media print': {
            padding: '2mm',
          },
        }}
      >
        {farmSatelliteData.latest_satellite_image ? (
          <AmSatelliteReportMapSection
            tile={farmSatelliteData.latest_satellite_image.tile}
            polygon={farmSatelliteData?.polygon_data || []}
            activeTile={activeTile}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: 4,
            }}
          >
            <Alert
              severity="info"
              icon={<CloudOffIcon fontSize="large" />}
              sx={{
                width: '100%',
                '& .MuiAlert-icon': {
                  fontSize: '2rem',
                },
              }}
            >
              <AlertTitle sx={{ fontSize: '1.1rem' }}>
                {t('Satellite Data Unavailable')}
              </AlertTitle>
              <Typography>
                {t(
                  'Recent satellite imagery is not available due to cloud cover. Please check back later for updated data.'
                )}
              </Typography>
            </Alert>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AmReportSatelliteIndexSection;
